/*
 * @Author: PanYunhong
 * @Date: 2022-03-30 17:27:13
 * @LastEditors: PanYunhong
 * @LastEditTime: 2022-05-07 15:17:14
 * @description: 配置文档 https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \air_version_2\src\utils\AMap\urlPictureLayer\index.ts
 */
import CoorsOffset from '@/utils/coordinateConversions';

const coorsOffset = new CoorsOffset();

export default class urlPictureLayer extends AMap.TileLayer<any> {
  constructor (url :string, flagCallback:any) {
    super({
      getTileUrl (x:number,y:number,z:number) {
        const y1 = 2 ** z - 1 - y;

        return `${url}/${z}/${x}/${y1}.png`;
      },
      opacity: 0.7,
    });
    flagCallback(false);
    this.on('complete', () => {
      flagCallback(true);
    });
  }
}
